// extracted by mini-css-extract-plugin
export default {"More":"more_More__6NgzD","Icon":"more_Icon__KWn40"};